var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ul",
    { staticClass: "block" },
    _vm._l(_vm.answers, function (answer, index) {
      return _c(
        "li",
        { key: index, staticClass: "mt-2 columns is-mobile is-1" },
        [
          _c(
            "div",
            { staticClass: "column is-2 has-text-weight-semibold" },
            [
              _c("span", [_vm._v(_vm._s(_vm.answerLabels[index]))]),
              _vm._v(" "),
              _vm.correctAnswer == index
                ? _c("correct-status", {
                    staticClass: "ml-2",
                    attrs: { "is-correct": _vm.correctAnswer == index },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("html-content", {
            staticClass: "column",
            attrs: { body: answer },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }